import axios from 'axios';
import config from '../config';
import Cookies from 'universal-cookie'
import { getGlobalCookie, clearCookie, eraseGlobalCookie, getLocalStorageInfo, toastFlashMessage } from './';
import { trackLogOut } from './mixpanel';
import { triggerForceChangePasswordModal } from '../shared_elements/actionCreators';
import { toastPasswordExpiredOnce } from './snackbarUtils';
var axiosInstance = axios.create();
const cookies = new Cookies();
let ipRestrictionHandled = false;
axiosInstance.defaults.baseURL = config.api.networkInterface;
axiosInstance.interceptors.request.use(function (config) {
  let lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'));
  if (lessorAccess) {
    config['headers']['Authorization'] = lessorAccess.access;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
axiosInstance.interceptors.response.use(
  function (response) {
    if (response.data.statusCode == 3005) {
      if (!ipRestrictionHandled) {
        ipRestrictionHandled = true;
        toastFlashMessage("You are accessing from IP which is not whitelisted by your Admin. Please contact your SPARTA ADMIN", 'error');
        localStorage.clear();
        clearCookie('lessorAccess', '.sparta.aero', '/')
        eraseGlobalCookie('lessorAccess')
        eraseGlobalCookie('domain')
        eraseGlobalCookie('userName')
        eraseGlobalCookie('hasMultilLessorAccess')
        cookies.remove('lessorAccess', { path: "/", domain: "sparta.aero" })
        trackLogOut(getLocalStorageInfo())
        setTimeout(() => {
          window.location.assign('/login')
        }, 4000)
      }
    }
    if (response?.data?.statusCode === 1013) {
      toastPasswordExpiredOnce("Your password has expired. Please change your password.");
      triggerForceChangePasswordModal(response);
    }
    return response;
  },
  function (error) {
    return error.response;
  }
);
export default axiosInstance;
